<script>
import { BTooltip } from "bootstrap-vue";

export default {
  extends: BTooltip
};
</script>